import { createSlice } from "@reduxjs/toolkit";

export const SETTING_EMAIL_TEMPLATE = "settingEmailTemplate";

const settingEmailTemplateSlice = createSlice({
    name: SETTING_EMAIL_TEMPLATE,
    initialState: {
        isLoading: false,
        emailTemplateList: [],
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setEmailTemplateList(state, action) {
            state.emailTemplateList = action.payload;
        },
    },
});

export const { setIsLoading, setEmailTemplateList } = settingEmailTemplateSlice.actions;
export default settingEmailTemplateSlice.reducer;